//Models
PJQ.models.invoicing.PayableInvoice = PJQ.models.invoicing.Invoice.extend({
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'payableinvoices',
            value: this.id
        }]);
    },
    beforeSave: function () {
        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            w9Attachments: this.w9Attachments.toJSON(),
            coiAttachments: this.coiAttachments.toJSON(),
            lienWaiverAttachments: this.lienWaiverAttachments.toJSON(),
        });
    },
    parse: function (model) {
        if (!model)
            return model;

        this.lineItems = new PJQ.collections.invoicing.PayableInvoiceLineItems(model.lineItems);
        this.attachments = new PJQ.collections.invoicing.PayableInvoiceAttachments(model.attachments);
        this.w9Attachments = new PJQ.collections.commitments.CommitmentAttachments(model.w9Attachments);
        this.coiAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.coiAttachments);
        this.lienWaiverAttachments = new PJQ.collections.commitments.CommitmentAttachments(model.lienWaiverAttachments);
        this.payments = new PJQ.collections.invoicing.PayableInvoicePayments(model.payments);

        if (model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        }

        if (model.invoiceContact) {
            if (model.invoiceContact instanceof PJQ.models.BaseModel) {
                this.invoiceContact = model.invoiceContact;
            } else {
                this.invoiceContact = new PJQ.models.contacts.Contact(model.invoiceContact);
            }
        }

        return model;
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/bill?txnId=' + externalId;
            default:
                return '';
        }
    },
    submit: function (signature, callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/submit',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                this.set(this.parse(response));
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    updateInviteStatus: async function (response, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/invitestatus?response=' + response,
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (res) {
            callback(res);
        }, this)).fail(_.bind(function (xhr, err, result) {
            PJQ.notifications.notify.errorNotify({
                message: err && err.message ? err.message : "Something went wrong"
            });
        }, this));
    }
});

PJQ.models.invoicing.PayableInvoiceHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'email': 'Email Sent',
        'invtobill': 'Sent Invite to Bill'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.invoicing.payableInvoiceStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.invoicing.payableInvoiceStatusNames[toStatus];
            case 'email':
            case 'invtobill':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.invoicing.PayableInvoiceLineItem = PJQ.models.invoicing.InvoiceLineItem.extend({});

PJQ.models.invoicing.PayableInvoiceAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.invoicing.PayableInvoiceCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.invoicing.PayableInvoiceSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'payableinvoices'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.invoicing.PayableInvoiceUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.invoicing.PayableInvoiceFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'payableinvoices'
            }
        ]);
    }
});

PJQ.models.invoicing.PayableInvoicePayment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'payableinvoicepayments',
            value: this.id
        }]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.invoicing.PayableInvoiceAttachments(model.attachments);

        if (model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        } else {
            this.contractedContact = null;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.toJSON()
        });
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/invoice?txnId=' + externalId;
            default:
                return '';
        }
    }
});

PJQ.models.invoicing.PayableInvoicePaymentAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

//Collections
PJQ.collections.invoicing.PayableInvoices = PJQ.collections.invoicing.Invoices.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoice,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }

        if (this.options.commitment != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'payableinvoices',
                    value: this.options.commitment.id
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'payableinvoices',
                    value: this.options.commitment ? this.options.commitment.id : null
                }
            ], params);
        }
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        result[PJQ.constants.invoicing.payableInvoiceStatus.DRAFT] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.REVIEWING] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.APPROVED] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE] = 0;
        result[PJQ.constants.invoicing.payableInvoiceStatus.REVISE] = 0;
        _.each(this.models, function (invoice) {
            result[invoice.get('statusId')] += invoice.get('amount');
        });
        return result;
    },
    getPayments: function () {
        let result = [];
        _.each(this.models, function (invoice) {
            result.push(...invoice.payments.models);
        })
        return result;
    }
});

PJQ.collections.invoicing.PayableInvoiceHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.invoicing.PayableInvoiceLineItems = PJQ.collections.invoicing.InvoiceLineItems.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceLineItem
});

PJQ.collections.invoicing.PayableInvoiceAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.invoicing.PayableInvoiceCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceCustomField,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push(...[
            {
                endpoint: 'payableinvoices'
            },
            {
                endpoint: 'customfields'
            }
        ]);
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

PJQ.collections.invoicing.PayableInvoiceCustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceCustomFieldChoice
});

PJQ.collections.invoicing.PayableInvoiceFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoiceFieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'payableinvoices'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'payableinvoices'
            }
        ]);
    }
});

PJQ.collections.invoicing.PayableInvoicePayments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoicePayment,
    endpoint: function () {
        if (this.options.invoiceId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'payableinvoices',
                    value: this.options.invoiceId
                },
                {
                    endpoint: 'payments'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'payableinvoicepayments'
                }
            ]);
        }
    },
});

PJQ.collections.invoicing.PayableInvoicePaymentAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.PayableInvoicePaymentAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'payableinvoicepayments',
                value: this.options.paymentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});